import Vue from 'vue';
import Vuex from 'vuex';
import login from './store/login.js';
import category from '@/store/category';
import question_type from '@/store/question_type';
import notification from '@/store/notification';
import featureflag from '@/store/featureflag';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    login,
    category,
    featureflag,
    question_type,
    notification,
  },
});
